


export default {

    head() {
        return {
            title: `Classement des villes et communes de France : ${this.ranking.name} - ${this.currentFilterName} ${(this.pagenumber > 1) ? ' - Page ' + this.pagenumber : ''} - ${this.$config.siteTitle}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.ranking.description
                }
            ]
        }
    },

    async asyncData({ params, $axios, $config: { baseApiURL }, error }) {
        const extraUrlParam = ((params.filter) ? '/' + params.filter : '')
            + ((params.pagenumber) ? '/page/' + params.pagenumber : '');

        const props = await $axios.$get(`${baseApiURL}/classements/${params.classement}${extraUrlParam}`)

        if (!props.cities.data.length) {
            return error({ statusCode: 404, message: 'Page not found' });
        }

        return {
            cities: props.cities,
            ranking: props.ranking,
            filters: props.filters,
            first_city: props.first_city,
            currentFilter: props.currentFilter,
            currentFilterName: props.currentFilterName,
            startAt: props.startAt,
            breadcrumbs: props.breadcrumbs,
            pagenumber: (params.pagenumber) ? params.pagenumber : 1
        }
    }
}
